import { render, staticRenderFns } from "./MetricDefinition.vue?vue&type=template&id=8df3a744&scoped=true"
import script from "./MetricDefinition.vue?vue&type=script&lang=js"
export * from "./MetricDefinition.vue?vue&type=script&lang=js"
import style0 from "./MetricDefinition.vue?vue&type=style&index=0&id=8df3a744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df3a744",
  null
  
)

export default component.exports